var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPermissionGps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2592 17.1059C16.3192 17.211 19.3169 18.1112 19.2792 19.6233C19.2792 21.1529 16.4592 22.1184 12.241 22.1184C8.1156 22.1184 5.25 21.1991 5.25 19.6121C5.25 18.159 8.22727 17.0915 9.13476 17.1059",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2644 10.2482C13.5674 10.2482 14.6236 9.17817 14.6236 7.85823C14.6236 6.53829 13.5674 5.46826 12.2644 5.46826C10.9615 5.46826 9.90527 6.53829 9.90527 7.85823C9.90527 9.17817 10.9615 10.2482 12.2644 10.2482Z",
    stroke: "#485058",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.241 19.6235C12.241 19.6235 17.5177 11.308 17.7898 8.11817C17.9659 5.93692 16.3004 2.34082 12.2646 2.25C8.32953 2.29621 6.57903 5.68677 6.66868 7.85686C6.82281 11.1646 12.241 19.6235 12.241 19.6235Z",
    stroke: "#485058",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPermissionGps);
export default __webpack_public_path__ + "static/media/ic_permission_gps.f5e5f82855d38210ebd60c29eca18cf8.svg";
export { ForwardRef as ReactComponent };